import { render, staticRenderFns } from "./MatchReadyLockStep.vue?vue&type=template&id=27ca1ffc"
import script from "./MatchReadyLockStep.vue?vue&type=script&lang=js"
export * from "./MatchReadyLockStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports